import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=202d204e&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202d204e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('202d204e')) {
      api.createRecord('202d204e', component.options)
    } else {
      api.reload('202d204e', component.options)
    }
    module.hot.accept("./EventList.vue?vue&type=template&id=202d204e&scoped=true", function () {
      api.rerender('202d204e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/EventList.vue"
export default component.exports